import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Users, Calendar, DollarSign } from "lucide-react";

const nightlyRates = [
  { people: "1-2 people", rate: "$40.00" },
  { people: "3-4 people", rate: "$45.00" },
  { people: "5-7 people", rate: "$50.00" },
  { people: "8-10 people", rate: "$60.00" }
];

const monthlyRates = [
  { type: "Small Lot", size: "25'-35' W x 50' L", rate: "$380.00" },
  { type: "Large Lot", size: "25'-35' W x 75' L", rate: "$395.00" }
];

export function RatesSection() {
  return (
    <section id="rates" className="py-20 bg-gradient-to-b from-fun-blue/5 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4 text-fun-navy">
            Rates & Pricing
          </h2>
          <p className="text-lg text-muted-foreground">
            Competitive rates for both short-term and long-term stays
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Nightly Rates */}
          <Card className="border-fun-blue/20">
            <CardHeader className="text-center">
              <div className="mx-auto bg-fun-blue/10 p-3 rounded-full w-fit mb-4">
                <Calendar className="h-8 w-8 text-fun-blue" />
              </div>
              <CardTitle className="text-2xl text-fun-navy">Nightly Rates</CardTitle>
              <p className="text-muted-foreground">Perfect for short stays and travelers</p>
            </CardHeader>
            <CardContent className="space-y-4">
              {nightlyRates.map((rate, index) => (
                <div key={index} className="flex justify-between items-center p-4 bg-fun-blue/5 rounded-lg border border-fun-blue/10">
                  <div className="flex items-center gap-2">
                    <Users className="h-4 w-4 text-fun-teal" />
                    <span className="text-fun-navy">{rate.people}</span>
                  </div>
                  <span className="font-semibold text-primary">{rate.rate}</span>
                </div>
              ))}
              <div className="text-sm text-muted-foreground mt-4">
                <p>* Local taxes apply</p>
                <p>* No weekly rates currently offered</p>
              </div>
            </CardContent>
          </Card>

          {/* Monthly Rates */}
          <Card className="border-primary/20 shadow-lg">
            <CardHeader className="text-center">
              <div className="mx-auto bg-primary/10 p-3 rounded-full w-fit mb-4">
                <DollarSign className="h-8 w-8 text-primary" />
              </div>
              <CardTitle className="text-2xl text-fun-navy">Monthly Rates</CardTitle>
              <p className="text-muted-foreground">Ideal for snowbirds and extended stays</p>
              <Badge variant="secondary" className="bg-fun-teal text-white">Most Popular</Badge>
            </CardHeader>
            <CardContent className="space-y-4">
              {monthlyRates.map((rate, index) => (
                <div key={index} className="p-4 bg-primary/5 rounded-lg border border-primary/10">
                  <div className="flex justify-between items-start mb-2">
                    <div>
                      <h4 className="font-semibold text-fun-navy">{rate.type}</h4>
                      <p className="text-sm text-muted-foreground">{rate.size}</p>
                    </div>
                    <span className="font-semibold text-primary text-lg">{rate.rate}</span>
                  </div>
                </div>
              ))}
              <div className="text-sm text-muted-foreground mt-4">
                <p>* Local taxes apply</p>
                <p>* $50.00 deposit required for long-term stays</p>
                <p>* Discounted summer storage rates available</p>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="text-center mt-12">
          <Card className="max-w-2xl mx-auto bg-fun-yellow/10 border-fun-yellow/30">
            <CardContent className="p-6">
              <h3 className="font-semibold mb-4 text-fun-navy">Payment Methods Accepted</h3>
              <p className="text-muted-foreground">
                We accept Visa, Mastercard, Discover, American Express, debit cards, cash, and checks
              </p>
              <Button className="mt-4 bg-primary hover:bg-primary/90">
                Make Reservation Today
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
}